var Curriculog = Curriculog || {};

Curriculog.PagingParams = (function ($, _, Backbone, PagingParams) {
	
	PagingParams = Curriculog.Param.extend({
		defaults: function() {
			return {
				limit: ($('#limit').length) ?
					$('#limit').val() : 10,
				page: 1
			};
		},

		initialize: function(model, options) {
			this.setAttr(options);
			this.listenTo(Backbone, 'tabs:change', this.reset);
			this.listenTo(Backbone, 'page:reset', this.reset);
		},

		setAttr: function(attributes) {
			attributes = _.pick(attributes, _.keys(this.defaults()));
			this.set(attributes);
			return this.attributes;
		},

		reset: function() {
			this.set('page', 1);
		},

		getRange: function() {
			var page = this.get('page'),
				limit = this.get('limit');

			var pageStart = (page - 1) * limit;
			var pageEnd = parseInt(pageStart, 10) + parseInt(limit, 10);
			
			return {
				pageStart: pageStart,
				pageEnd: pageEnd
			};
		},

	});

	return PagingParams;

})($, _, Backbone, Curriculog.PagingParams || {});